import React, { useEffect, useState } from 'react';
import { api } from '../lib/api';
import { toast } from 'sonner';
import { PauseCircle } from 'lucide-react';
import { Switch } from './ui/switch';

// Admin card (Team Management): pause new deals entering the pipeline.
export function IntakeFreezeCard() {
  const [enabled, setEnabled] = useState(false);
  const [meta, setMeta] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.getIntakeFreeze().then((res) => {
      setEnabled(!!res.data?.enabled);
      setMeta(res.data);
    }).catch(() => {});
  }, []);

  const toggle = async (value) => {
    setEnabled(value);
    setSaving(true);
    try {
      await api.setIntakeFreeze(value);
      toast.success(value
        ? 'Deal intake paused — claiming new deals & adding to the meeting agenda is now disabled'
        : 'Deal intake resumed');
    } catch (err) {
      setEnabled(!value);
      toast.error(err.response?.data?.detail || 'Failed to update');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className={`border rounded-sm p-4 sm:p-5 ${enabled ? 'bg-amber-500/5 border-amber-500/30' : 'bg-card border-border'}`}
      data-testid="intake-freeze-card">
      <div className="flex items-start justify-between gap-4">
        <div>
          <h3 className="font-heading text-lg text-foreground flex items-center gap-2 mb-1">
            <PauseCircle className={`w-4.5 h-4.5 ${enabled ? 'text-amber-400' : 'text-blue-400'}`} style={{ width: 18, height: 18 }} />
            Pause Deal Intake
          </h3>
          <p className="text-xs text-muted-foreground max-w-lg">
            When paused, nobody can claim new deals from the TAM or add new deals to the team meeting agenda —
            the team focuses on deals already in the pipeline. Existing deals, tasks and SLAs keep running normally.
          </p>
          {enabled && meta?.set_by && (
            <p className="text-[11px] text-amber-400 mt-2" data-testid="intake-freeze-status">
              ⏸ Intake paused{meta.set_by ? ` by ${meta.set_by}` : ''}
            </p>
          )}
        </div>
        <Switch checked={enabled} onCheckedChange={toggle} disabled={saving} data-testid="intake-freeze-switch" />
      </div>
    </div>
  );
}
